import api from '@/libs/axios'
import qs from 'qs'

const endpoint = '/mcu_booking'

const service = {
    getAll: async (params) => {
        try {
            const result = await api.get(endpoint, {
                params: params,
                paramsSerializer: (params) => {
                    return qs.stringify(params)
                }
            })
            return result.data
        } catch {
            return null
        }
    },
    getTatBookingList: async (params) => {
        try {
            const result = await api.get(`${endpoint}/tat-booking-list`, {
                params: params,
                paramsSerializer: (params) => {
                    return qs.stringify(params)
                }
            })
            return result.data
        } catch {
            return null
        }
    },
    getOne: async (params) => {
        try {
            const result = await api.get(`${endpoint}/${params.id}`)
            return result.data
        } catch {
            return null
        }
    },
    getHistory: async (params) => {
        try {
            const result = await api.get(`${endpoint}/${params.id}/history`)
            return result.data
        } catch {
            return null
        }
    },
    getPendingCount: async (params) => {
        try {
            const result = await api.get(`${endpoint}/pending-count`, { params: params })
            return result.data
        } catch {
            return null
        }
    },
    /** FormData must use POST: multipart PATCH often yields empty input on the server; route matches POST + PATCH. */
    update: async (params) => {
        const config = { skipLayoutError: true }
        const url = `${endpoint}/${params.id}`
        const result = await api.post(url, params.data, config)
        return result.data
    },
    add: async (params) => {
        const result = await api.post(endpoint, params, { skipLayoutError: true })
        return result.data
    },
    delete: async (params) => {
        const result = await api.delete(`${endpoint}/${params.id}`, { data: params, skipLayoutError: true })
        return result.data
    },
    exportCSV: async (params) => {
        try {
            const result = await api.get(`${endpoint}/export`, {
                params: params,
                paramsSerializer: (params) => {
                    return qs.stringify(params)
                }
            })
            return result.data
        } catch {
            return null
        }
    },
    getFacilitiesByPackageGroup: async (packageGroupId) => {
        try {
            const result = await api.get(`${endpoint}/package-group-facilities`, {
                params: { package_group_id: packageGroupId }
            })
            return result.data
        } catch {
            return null
        }
    },
    getFacilities: async (params) => {
        try {
            const result = await api.get('/facilities', {
                params: { per_page: 'all', status: 'ACTIVE', ...params }
            })
            return result.data
        } catch {
            return null
        }
    },
    getAvailableSlot: async (params) => {
        try {
            const { date, facility_id, package_group_id, package_id } = params
            const result = await api.get(`/capacity/available-slot/${date}/${facility_id}`, {
                params: {
                    ...(package_group_id ? { package_group_id } : {}),
                    ...(package_id ? { package_id } : {})
                }
            })
            return result.data
        } catch {
            return null
        }
    },
    getAvailableDates: async (params) => {
        try {
            const { facility_id, package_id } = params
            const result = await api.get(`/capacity/${facility_id}/available-dates`, {
                params: {
                    ...(package_id ? { package_id } : {})
                }
            })
            return result.data
        } catch {
            return null
        }
    },
    packageDateBooking: async (payload) => {
        const config = { skipLayoutError: true }
        const result = await api.post(`${endpoint}/package-date-booking`, payload, config)
        return result.data
    }
}

export { service }
